import {
  VIEWPORT_TOOLSET_IDS,
  VIEWPORT_TOOLSET_PLACEMENTS,
  type ViewportToolsetId,
  type ViewportToolsetPlacement,
} from "@/viewport-tools/core";

export const VIEWPORT_VIEW_IDS = {
  takeoffPilot: "takeoff-pilot",
  takeoffPilotReadOnly: "takeoff-pilot-read-only",
  fieldPilot: "field-pilot",
} as const;

export type ViewportViewId =
  (typeof VIEWPORT_VIEW_IDS)[keyof typeof VIEWPORT_VIEW_IDS];

export interface ViewportToolsetViewConfig {
  placements: Partial<Record<ViewportToolsetPlacement, ViewportToolsetId[]>>;
}

export const VIEWPORT_TOOLSET_VIEW_CONFIGS: Record<
  ViewportViewId,
  ViewportToolsetViewConfig
> = {
  [VIEWPORT_VIEW_IDS.takeoffPilot]: {
    placements: {
      [VIEWPORT_TOOLSET_PLACEMENTS.topToolbar]: [
        VIEWPORT_TOOLSET_IDS.scale,
        VIEWPORT_TOOLSET_IDS.measurement,
        VIEWPORT_TOOLSET_IDS.tags,
      ],
      [VIEWPORT_TOOLSET_PLACEMENTS.leftRail]: [
        VIEWPORT_TOOLSET_IDS.scale,
        VIEWPORT_TOOLSET_IDS.measurement,
        VIEWPORT_TOOLSET_IDS.tags,
      ],
    },
  },
  [VIEWPORT_VIEW_IDS.takeoffPilotReadOnly]: {
    placements: {
      [VIEWPORT_TOOLSET_PLACEMENTS.leftRail]: [
        VIEWPORT_TOOLSET_IDS.scale,
        VIEWPORT_TOOLSET_IDS.tags,
      ],
    },
  },
  [VIEWPORT_VIEW_IDS.fieldPilot]: {
    placements: {
      [VIEWPORT_TOOLSET_PLACEMENTS.topToolbar]: [
        VIEWPORT_TOOLSET_IDS.scale,
        VIEWPORT_TOOLSET_IDS.measurement,
        VIEWPORT_TOOLSET_IDS.tags,
      ],
      [VIEWPORT_TOOLSET_PLACEMENTS.leftRail]: [
        VIEWPORT_TOOLSET_IDS.scale,
        VIEWPORT_TOOLSET_IDS.measurement,
        VIEWPORT_TOOLSET_IDS.tags,
      ],
    },
  },
};

const EMPTY_VIEWPORT_TOOLSET_IDS: ViewportToolsetId[] = [];

export function getViewportToolsetViewConfig(
  viewId: ViewportViewId
): ViewportToolsetViewConfig {
  return VIEWPORT_TOOLSET_VIEW_CONFIGS[viewId];
}

export function getViewportToolsetsForPlacement(
  viewId: ViewportViewId,
  placement: ViewportToolsetPlacement
): ViewportToolsetId[] {
  return getViewportToolsetViewConfig(viewId).placements[placement] ?? EMPTY_VIEWPORT_TOOLSET_IDS;
}
